export default __webpack_public_path__ + "static/3-9fbdc24326287db7450aa643f15cc475.jpeg";